import * as React from "react";

export function MinimizeIcon() {
  return (
    <svg width="6" height="1" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        d="M.61.703h5.8"
      ></path>
    </svg>
  );
}

export default MinimizeIcon;
